import type { JsonSchemaObject } from '@onefootprint/request-types/dashboard';

// The output type a user can select for a node's data assignment (external API extraction, code exec
// output, ...). Mirrors the backend `InstanceType` minus `null`, plus a synthetic "any" for an
// untyped/unknown value.
export type OutputType = 'any' | Exclude<JsonSchemaObject['type'], 'null' | undefined>;

// The selectable types, in display order. Each node maps over these with its own i18n keyPrefix to
// build the dropdown options.
export const outputTypes = [
  'any',
  'string',
  'integer',
  'number',
  'boolean',
  'object',
  'array',
] as const satisfies readonly OutputType[];

// Derive the form's type selection from a stored `output_schema`.
export const outputTypeFromSchema = (schema: JsonSchemaObject | undefined): OutputType => {
  const type = schema?.type;
  return type && type !== 'null' ? type : 'any';
};

// Lower a form type selection into an `output_schema`. "any" is the empty schema (matches any JSON
// value); a concrete type is `{ type }`. Optionality is carried separately via `is_required`.
// Omitting the schema entirely maintains the legacy behavior.
export const outputSchemaFromType = (type: OutputType): JsonSchemaObject => {
  return type === 'any' ? {} : { type };
};
